module.exports = __webpack_public_path__ + "img/risks@3x.d9b08e57.png";